import { useState } from 'react'
import { useGetEthicsSubmissionsQuery } from '@/core/services/form'
import { FormSubmissionStatus } from '@/core/models/form.model'

export function useEthicsSubmissions() {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [statusFilter, setStatusFilter] = useState<FormSubmissionStatus | ''>('')

  const { data, isError, isLoading, refetch } = useGetEthicsSubmissionsQuery({
    ...(statusFilter && { status: statusFilter }),
    limit: rowsPerPage,
    skip: page * rowsPerPage,
    order: 'DESC',
    orderBy: 'createdAt',
  })

  const submissions = data?.items || []
  const totalCount = data?.totalCount || 0

  const statusCounts = {
    submitted: submissions.filter((submission) => submission.status === FormSubmissionStatus.Submitted).length,
    resolved: submissions.filter((submission) => submission.status === FormSubmissionStatus.Resolved).length,
  }

  const handleStatusFilterChange = (status: FormSubmissionStatus | '') => {
    setStatusFilter(status)
    setPage(0)
  }

  const handleRowsPerPageChange = (nextRowsPerPage: number) => {
    setRowsPerPage(nextRowsPerPage)
    setPage(0)
  }

  return {
    submissions,
    totalCount,
    isError,
    isLoading,
    page,
    rowsPerPage,
    statusFilter,
    statusCounts,
    setPage,
    refetch,
    handleStatusFilterChange,
    handleRowsPerPageChange,
  }
}
